import { Dim, Entity } from '../../models';
import Metrics from '../renderers/Metrics';
import { INITIAL_HEALTH } from '../../constants/mechanics';
import { getReceptorDims, getNoteDims } from '../../helpers';

export default (windowDims: Dim, total: number): Entity => {
  const noteDims = getNoteDims(windowDims);
  const safeW = (windowDims.w - getReceptorDims(windowDims).w / 2) / 2;

  return {
    dims: {
      w: safeW,
      h: noteDims.h,
      b: noteDims.h / 8,
      m: Math.ceil(Math.min(safeW, noteDims.h) / 11),
    },
    getPos: () => ({ x: 0, y: windowDims.h }),
    hearts: INITIAL_HEALTH,
    special: false,
    points: 0,
    total,
    renderer: Metrics,
  };
};
